module.exports = __webpack_public_path__ + "img/bg.89610e51.jpg";